<template>
  <b-card v-if="cluster">
    <b-row>
      <b-col cols="10">
        <span>
          Registered date:
          <i
            >{{ cluster.createdAt | formatDateTime }} -
            {{ cluster.user.firstName }} {{ cluster.user.lastName }}</i
          > </span
        ><br />

        <span v-if="cluster.status === 2 || cluster.status === 0">
          End date:
          <i>
            {{ cluster.endDate | formatDateTime }} -
            {{
              cluster.finalUser
                ? cluster.finalUser.firstName + " " + cluster.finalUser.lastName
                : "No one"
            }}
          </i>
        </span>
        <br />
        <br />
        <span v-if="cluster.supplierCompany"
          >Supplier: <i> {{ cluster.supplierCompany.companyName }} </i>
        </span>
        <br />
        <br />
        <span
          >Status:
          <i> {{ statusDisplay.label }}</i>
        </span>
      </b-col>
      <b-col class="text-center">
        <div class="text-center">
          <span
            class="dot"
            :style="{ 'background-color': statusDisplay.variant }"
          />
          <br />

          <b-icon
            v-if="cluster.status === 1 && userHasPermission('cluster', 'write')"
            icon="check-square"
            scale="1.3"
            class="m-1 cursor-pointer"
            id="cluster-status-btn-4"
            @click="updateClusterStatus(2)"
          ></b-icon>
          <b-tooltip target="cluster-status-btn-4">Mark as completed</b-tooltip>
          <b-icon
            v-if="cluster.status === 1 && userHasPermission('cluster', 'write')"
            icon="x-square"
            class="m-1 cursor-pointer"
            id="cancel-work-order"
            scale="1.3"
            @click="showCancelNote = true"
          ></b-icon>
          <b-tooltip target="cancel-work-order">Cancel</b-tooltip>
        </div>
      </b-col>
      <b-col v-if="showCancelNote">
        <b-form-group label="Note">
          <b-form-textarea
            v-model="note"
            class="resize-none"
            aria-describedby="input-description-live-feedback"
          />
        </b-form-group>
        <!-- Cancel button and confirm button -->
        <b-row>
          <b-col sm="12" md="12" lg="12" xl="12" class="">
            <div class="float-right">
              <b-btn
                size="lg"
                class="btn btn-danger mr-2"
                type="button"
                @click="showCancelNote = false"
              >
                Cancel
              </b-btn>

              <b-btn
                size="lg"
                class="btn btn-success"
                type="button"
                @click="updateClusterStatus(0)"
              >
                Confirm
              </b-btn>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col v-if="cluster.note">
        <span>
          Note: <i>{{ cluster.note }}</i>
        </span>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { PUT_CLUSTER } from "./actions";
import { generalMixin } from "@/modules/mixin.js";
import { superAdminMixin } from "../../mixins";

export default {
  components: {},
  props: ["cluster", "refreshData"],
  mixins: [generalMixin, superAdminMixin],

  data() {
    return {
      showCancelNote: false,
      note: "",
    };
  },
  computed: {
    statusDisplay() {
      switch (this.cluster.status) {
        case 0:
          return { variant: "#dc3545", label: "Canceled" };
        case 1:
          return { variant: "#fd7e14", label: "Active" };
        case 2:
          return { variant: "#54b962", label: "Validated and quoted" };
        default:
          return { variant: "#6c757d", label: "Unknown" };
      }
    },
  },
  methods: {
    updateClusterStatus(status) {
      this.$store
        .dispatch(PUT_CLUSTER, {
          id: this.cluster.id,
          status: status,
          note: this.note,
        })
        .then(() => {
          this.refreshData();
          this.$root.$bvToast.toast("Cluster status updated", {
            title: "Success",
            variant: "success",
          });
        })
        .catch(() => {
          this.$root.$bvToast.toast("Cluster could not update", {
            title: "Error",
            variant: "warning",
          });
        });
    },
  },
};
</script>

<style></style>
